export var stickyMenu = () => {
    var myDillardsBarHeight = $('.myDillardsSpacer').height(),
        stickyNavTop = ($('#main-nav').length) ? $('#main-nav').offset().top : 0; /* NOTE! TERNARY CHECK ON THE stickyNavTop VARIABLE SHOULD, MOST LIKELY, BE REMOVED FOR PRODUCTION! */

    var stickyNav = function() {
        var scrollTop = $(window).scrollTop(),
            $htmlTouch = $('html.touch'),
            $htmlNoTouch = $('html.no-touchevents'),
            $myDillardsBar = $('#topbar-wrapper #myDillardsBar'),
            $myDillardsSpacer = $('.myDillardsSpacer'),
            $mainNav = $('#main-nav'),
            $stickyNav = $('.sticky-nav-bg ');

        if ($htmlTouch.length) {
            $myDillardsBar.css({
                'position': 'relative'
            });

            $myDillardsSpacer.css({
                'display': 'none'
            });
        }

        const siteSearch = document.querySelector('.site-search');
        if ($htmlNoTouch.length) {
            const initialPosition = window.pageYOffset || document.documentElement.scrollTop;
			if (siteSearch.getBoundingClientRect().top <= 1 && initialPosition > 0) {
            $mainNav.addClass('sticky');
              $stickyNav.addClass('sticky');
            } else{
               $mainNav.removeClass('sticky');
                $stickyNav.removeClass('sticky');
            }
        }
    };

   $(window).on('scroll', function(){
        stickyNav();
  });
};
